import { environment } from '../../../environments/environment';

export const msalConfig = environment.msalConfig;
